<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        DTO Outbound Component
        <p class="pl-4">|</p>
      </h1>
      <!-- <p class="pr-4"></p>
      <vs-button
        color="#5b3cc4"
        type="filled"
        icon="cloud_upload"
        @click="upload"
        >Upload</vs-button
      > -->
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="visibility"
        @click="cusView"
        v-if="btndis"
        >View</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="check"
        @click="goApproveMTO"
        v-if="btndis"
        >Approve</vs-button
      >
      <!-- <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="unarchive"
          color="success"
          v-if="btndis"
          >Approve</vs-button
        >

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goApprove">DTO</vs-dropdown-item>
          <vs-dropdown-item @click="goApproveMTO">MTO</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>-->
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="flag"
        @click="goReject"
        v-if="btndis"
        >Reject</vs-button
      >
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="unarchive"
          color="success"
          v-if="btndis"
          >Picking</vs-button
        >

        <vs-dropdown-menu>
          <!-- <vs-dropdown-item @click="goPick">All</vs-dropdown-item> -->
          <vs-dropdown-item @click="goPickMain">Pick Main</vs-dropdown-item>
          <vs-dropdown-item @click="goShip">Ship Main</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <exberror v-if="errorshow" key="errorshow" :errdata="errdata"></exberror>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <inbupload
        v-if="comUpload"
        key="comUpload"
        @done="uploadDone"
      ></inbupload>
      <exview
        v-if="viewshow"
        key="viewshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
      ></exview>
      <inbadd
        v-if="addshow"
        key="addshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
      ></inbadd>
      <aggrid
        v-if="gridshow"
        key="gridshow"
        @recsel="recsel"
        @mousedown.middle.native="getXY"
      ></aggrid>
    </transition-group>

    <vs-popup title="ชื่อเจ้าหน้าที่" :active.sync="popupActive2">
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>ผู้อนุมัติ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="approval"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button
              v-if="validName"
              color="success"
              type="filled"
              icon="check"
              @click="acceptConfirm"
              >Approve</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="ชื่อเจ้าหน้าที่" :active.sync="popupActive4">
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>ผู้อนุมัติ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="approval"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button
              v-if="validName"
              color="success"
              type="filled"
              icon="check"
              @click="acceptConfirm2"
              >Approve</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="ชื่อเจ้าหน้าที่" :active.sync="popupActive3">
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>ผู้ยกเลิก</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="rejector"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button
              v-if="validName2"
              color="danger"
              type="filled"
              icon="flag"
              @click="acceptReject"
              >Reject</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import inbadd from "./exbadd.vue";
import inbupload from "./inbupload";
import exberror from "./exberror";
import exview from "./exview.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      pickordersNumber: "",
      locationsCode: "",
      errorshow: false,
      popupActive3: false,
      popupActive2: false,
      popupActive4: false,
      approval: "",
      rejector: "",
      viewshow: false,
      addshow: false,
      gridshow: false,
      btndis: false,
      comUpload: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goDetail", label: "Inbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    validName() {
      return this.approval.length > 0;
    },
    validName2() {
      return this.rejector.length > 0;
    },
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    goPickMain() {
      this.$router.replace("/picking");
    },
    goShip() {
      this.$router.replace("/ships");
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    uploadDone() {
      // alert("Done");
      this.comUpload = false;
    },
    upload() {
      this.viewshow = false;
      this.comUpload = true;
      this.addshow = false;
      this.viewshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.errorshow = false;
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
      this.errorshow = false;
    },
    goDetail() {
      this.btndis = true;
      localStorage.setItem("LS_Page", this.$route.path);
      this.$router.replace("/Inbdetails/" + this.recid);
    },
    goPrint() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Print Error",
          text: "Some Inbound Item Error",
        });
      } else {
        const formData = {
          token: localStorage.getItem("token"),
          dbname: localStorage.getItem("dbname"),
          number: this.recid,
        };
        axios
          .post("/ApiInbPreprint", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Print Error",
                text: res.data.message,
                fixed: true,
              });
            } else {
              let url = localStorage.getItem("appdb");
              let dbname = localStorage.getItem("dbname");
              window.open(
                url + "api/ApiInbdetailsPrintAll/" + this.recid + "/" + dbname
              );
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: err,
            });
          });
      }
    },
    cusAdd() {
      this.viewshow = false;
      this.comUpload = false;
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
      this.errorshow = false;
    },
    grid() {
      this.errorshow = false;
      this.viewshow = false;
      this.gridshow = false;

      this.comUpload = false;
      this.addshow = false;
      setTimeout(() => {
        this.gridshow = true;
      }, 300);
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    cusView() {
      this.errorshow = false;
      this.viewshow = true;
      this.comUpload = false;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusEdit() {
      this.errorshow = false;
      this.viewshow = false;
      this.comUpload = false;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      this.errorshow = false;
      this.btndis = false;
      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        number: this.recid,
      };
      axios
        .post("/ApiDelInborders", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: res.data.message,
            });
          } else {
            this.$store.dispatch("setReportGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });

      // this.gridshow = false;
      // this.gridshow = true;
    },
    goApprove() {
      this.approval = "";
      this.popupActive2 = true;
    },
    async acceptConfirm() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formDataf = {
            number: this.recid,
            approval: this.approval,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const responsef = await axios.post(
            `${BASE_API_URL}/outbound-svc/tmoexs/tmosConfirmOut`,
            formDataf,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (responsef.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: responsef.data.message,
            });

            this.errdata = responsef.data.errdata;
            this.errorshow = true;
          } else {
            // console.log(responsef.data.message.number);
            const formData = {
              number: responsef.data.message.number,
              editor: String(this.userid),
              companyGroupsCode: this.companyGroupsCode,
            };

            const response = await axios.post(
              `${BASE_API_URL}/outbound-svc/tmoexs/exbMTOCnpick`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });

              this.errdata = response.data.errdata;
              this.errorshow = true;
            } else {
              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "exbCnpick Complete",
                text: response.data.message,
              });
              this.pickOrdersNumber = response.data.picknum;

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "cnPick Complete",
                text: response.data.message,
              });

              const formData3 = {
                pickOrdersNumber: this.pickOrdersNumber,
                editor: String(this.userid),
                companyGroupsCode: this.companyGroupsCode,
              };

              const response3 = await axios.post(
                `${BASE_API_URL}/outbound-svc/tmoexs/cnShipItemMTO`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
              // console.log(response3.data);

              if (response3.data.status != "success") {
                this.loading = false;
                this.$vs.notify({
                  position: "top-right",
                  color: "danger",
                  title: "Error from Backend",
                  text: response3.data.message,
                });

                this.errdata = response3.data.errdata;
                this.errorshow = true;
              } else {
                this.$vs.notify({
                  position: "top-right",
                  color: "success",
                  title: "Ship Complete",
                  text: response3.data.message,
                });

                this.approval = "";
                this.popupActive2 = false;

                if (this.$store.state.reportgrid == 0) {
                  this.$store.dispatch("setReportGrid", 1);
                } else {
                  this.$store.dispatch("setReportGrid", 0);
                }
              }
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    goApproveMTO() {
      this.approval = "";
      this.popupActive4 = true;
    },
    async acceptConfirm2() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;
        this.popupActive4 = false;

        if (token) {
          const formDataf = {
            number: this.recid,
            approval: this.approval,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const responsef = await axios.post(
            `${BASE_API_URL}/outbound-svc/tmoexs/tmosConfirmOut`,
            formDataf,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (responsef.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: responsef.data.message,
            });

            this.errdata = responsef.data.errdata;
            this.errorshow = true;
          } else {
            // console.log(responsef.data.message.number);
            const formData = {
              number: responsef.data.message.number,
              editor: String(this.userid),
              companyGroupsCode: this.companyGroupsCode,
            };

            const response = await axios.post(
              `${BASE_API_URL}/outbound-svc/tmoexs/exbMTOCnpick`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });

              this.errdata = response.data.errdata;
              this.errorshow = true;
            } else {
              this.$router.replace("/pickdetails/" + response.data.picknum);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Picking Complete",
                text: response.data.message,
              });
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    goReject() {
      this.rejector = "";
      this.popupActive3 = true;
    },
    async acceptReject() {
      // console.log(this.approval);
      this.popupActive3 = false;
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            rejector: this.rejector,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/tmoexs/tmoexsReject`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Reject Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    this.grid();
  },
  components: {
    aggrid,
    inbupload,
    inbadd,
    exberror,
    exview,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
